import { render } from "./yflhc.vue?vue&type=template&id=45a6fa8c&scoped=true"
import script from "./yflhc.vue?vue&type=script&lang=js"
export * from "./yflhc.vue?vue&type=script&lang=js"

import "./yflhc.vue?vue&type=style&index=0&id=45a6fa8c&lang=scss&scoped=true"
import "./yflhc.vue?vue&type=style&index=1&id=45a6fa8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a6fa8c"]])

export default __exports__